import UsersHeader from '../components/UsersHeader';
import UsersTable from '../components/UsersTable';

export default function Users() {
    return (
        <div className="flex h-full bg-background">
            <div className="flex-1 flex flex-col">
                <UsersHeader />
                <UsersTable />
            </div>
        </div>
    );
}
